import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	model,
} from "@angular/core"
import { FormValueControl } from "@angular/forms/signals"
import { COMMON_IMPORTS } from "@app/common-imports"
import { OptionsList } from "@app/definitions/opts"
import { LangService } from "@app/services/lang.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "[option]",
	imports: [COMMON_IMPORTS, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `{{ option().lang | langVal }}`,
	host: {
		class: "btn",
		"[title]": "title()",
		"[class]": "cls()",
	},
})
export class Option {
	lang = inject(LangService)
	option = input.required<any>()
	title_ph_lang = input.required<string>()
	isSelected = input.required<boolean>()
	title = computed(
		() =>
			`${this.lang.getVal(this.title_ph_lang())}: ${this.lang.getVal(this.option().lang)}`
	)
	cls = computed(() => ({
		"btn-default": !this.isSelected(),
		"btn-primary": this.isSelected(),
		active: this.isSelected(),
	}))
}

@Component({
	selector: "btn-group-v2",
	imports: [COMMON_IMPORTS, Option],
	template: `
		<div
			class="button-group"
			[class.duo]="displayedOptions().length == 2"
		>
			@for (option of displayedOptions(); track option) {
				<button
					[option]="option"
					[title_ph_lang]="title_ph_lang() || optionsListName() || ''"
					[isSelected]="value() == option.value"
					(click)="value.set(option.value)"
				></button>
			}
		</div>
	`,
})
export class BtnGroupV2 implements FormValueControl<string> {
	title_ph_lang = input<string | null>(null)
	optionsListName = input<string | null>(null)
	value = model("")

	displayedOptions = computed(() => {
		return this.optionsListName()
			? OptionsList[this.optionsListName() || ""]
			: []
	})
}
